export enum BANNER_PERMISSIONS {
  BANNER_VIEW = 'CONTENT_BANNERSVIEW',
  BANNER_WRITE = 'CONTENT_BANNERSWRITE',
}
